// ═══ v2 화면 레지스트리 — 37 화면 React.lazy (수출업체 14 + 어드민 15 + 서류대행 3 + 운영 관리자 5) ═══
// W0 스텁은 v1 컴포넌트 re-export. 화면 에이전트가 screens/<id>.js 를 자기 구현으로 교체한다 (이 파일은 무변경).
// Dashboard.js 가 isV2 일 때 <Route element={<V2_SCREENS[id] ...v1 과 동일 props/>}> 로 소비 (Suspense 는 Dashboard 쪽).
import React from 'react';

export var V2_SCREEN_IDS = ['dashboard', 'car-list', 'car-register', 'cancel-tracking', 'cancel-doc-requests',
  'smart-upload', 'myunjang-queue', 'invoice', 'tax', 'tax-invoice', 'ledger', 'buyers', 'eval', 'settings',
  // 어드민 전용 13 (ADMIN2.md) — 관리자 v2 셸에서만 열린다. 다른 role 은 v1 경로 그대로.
  'companies', 'clearance-admin', 'carrier-admin', 'shoring-admin', 'dispatch-admin', 'clearance-queue',
  'admin-overview', 'bug-reports', 'admin-disputes', 'rfq', 'inquiries', 'transactions-confirm', 'cart-payments',
  'admin-accounts',
  // 푸시 발송 — 마스터와 운영 관리자가 같은 화면을 쓴다(라우트 표 양쪽에 배선).
  'admin-push',
  // 서류대행 전용 3 (roles-redesign/A-docagency.md) — doc_agency v2 셸에서 열린다.
  'docagency-dashboard', 'clearance-revisions', 'clearance-messages',
  // 운영 관리자 전용 6 — operator v2 셸에서만 열린다. 업체 데이터 화면은 하나도 없다(utils/operatorAccess.js 허용 목록 안).
  'operator-overview', 'operator-notices', 'operator-system', 'operator-bugs', 'operator-settings'];

export var V2_SCREENS = {
  'dashboard': React.lazy(function () { return import('./screens/dashboard'); }),
  'car-list': React.lazy(function () { return import('./screens/car-list'); }),
  'car-register': React.lazy(function () { return import('./screens/car-register'); }),
  'cancel-tracking': React.lazy(function () { return import('./screens/cancel-tracking'); }),
  'cancel-doc-requests': React.lazy(function () { return import('./screens/cancel-doc-requests'); }),
  'smart-upload': React.lazy(function () { return import('./screens/smart-upload'); }),
  'myunjang-queue': React.lazy(function () { return import('./screens/myunjang-queue'); }),
  'invoice': React.lazy(function () { return import('./screens/invoice'); }),
  'tax': React.lazy(function () { return import('./screens/tax'); }),
  'tax-invoice': React.lazy(function () { return import('./screens/tax-invoice'); }),
  'ledger': React.lazy(function () { return import('./screens/ledger'); }),
  'buyers': React.lazy(function () { return import('./screens/buyers'); }),
  'eval': React.lazy(function () { return import('./screens/eval'); }),
  'settings': React.lazy(function () { return import('./screens/settings'); }),
  // ── 어드민 전용 (ADMIN2.md) ──
  'companies': React.lazy(function () { return import('./screens/companies'); }),
  'clearance-admin': React.lazy(function () { return import('./screens/clearance-admin'); }),
  'carrier-admin': React.lazy(function () { return import('./screens/carrier-admin'); }),
  'shoring-admin': React.lazy(function () { return import('./screens/shoring-admin'); }),
  'dispatch-admin': React.lazy(function () { return import('./screens/dispatch-admin'); }),
  'clearance-queue': React.lazy(function () { return import('./screens/clearance-queue'); }),
  'admin-overview': React.lazy(function () { return import('./screens/admin-overview'); }),
  'bug-reports': React.lazy(function () { return import('./screens/bug-reports'); }),
  'admin-disputes': React.lazy(function () { return import('./screens/admin-disputes'); }),
  'rfq': React.lazy(function () { return import('./screens/rfq'); }),
  'inquiries': React.lazy(function () { return import('./screens/inquiries'); }),
  'transactions-confirm': React.lazy(function () { return import('./screens/transactions-confirm'); }),
  'cart-payments': React.lazy(function () { return import('./screens/cart-payments'); }),
  'admin-accounts': React.lazy(function () { return import('./screens/admin-accounts'); }),
  'admin-push': React.lazy(function () { return import('./screens/admin-push'); }),
  // ── 서류대행 전용 (A-docagency.md) ──
  'docagency-dashboard': React.lazy(function () { return import('./screens/docagency-dashboard'); }),
  'clearance-revisions': React.lazy(function () { return import('./screens/clearance-revisions'); }),
  'clearance-messages': React.lazy(function () { return import('./screens/clearance-messages'); }),
  // ── 운영 관리자 전용 ──
  'operator-overview': React.lazy(function () { return import('./screens/operator-overview'); }),
  'operator-notices': React.lazy(function () { return import('./screens/operator-notices'); }),
  'operator-system': React.lazy(function () { return import('./screens/operator-system'); }),
  'operator-bugs': React.lazy(function () { return import('./screens/operator-bugs'); }),
  'operator-settings': React.lazy(function () { return import('./screens/operator-settings'); })
};
